import { createStyles } from '@mantine/core';

export const useSupportStyles = createStyles((theme) => ({
  wrapper: {
    width: '76%',
    margin: 'auto',
    background: 'white',
    padding: 40,
    borderRadius: 20,
    marginTop: 30,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 30,
    boxShadow: '0px 20px 35px rgba(29, 94, 109, 0.03)',
    [theme.fn.smallerThan(1270)]: {
      width: 1000
    },
    [theme.fn.smallerThan(1050)]: {
      width: 800
    },
    [theme.fn.smallerThan(850)]: {
      width: '90%',
      padding: 10
    }
  },
  title: {
    fontFamily: `Medium, ${theme.fontFamily}`,
    fontSize: 26,
    fontWeight: 500,
    color: theme.colors.secondary[0]
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 6,
    width: '48%',
    [theme.fn.smallerThan(650)]: {
      width: '100%'
    }
  },
  inputFields: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: 20,
    [theme.fn.smallerThan(650)]: {
      flexDirection: 'column'
    }
  },
  label: {
    fontFamily: `Regular , ${theme.fontFamily}`,
    color: theme.colors.text[1],
    fontSize: 14,
    opacity: 0.5
  },
  textInput: {
    width: '100%',
    input: {
      padding: 23,
      borderRadius: 13,
      border: '2px solid white',
      outline: 'none',
      background: '#F7F9FA',
      transition: '.5s',
      fontFamily: `Medium , ${theme.fontFamily}`,
      fontSize: 13,
      borderColor: theme.colors.primary[0],
      background: '#E1F4F5',
      boxShadow: '0px 15px 25px 0px #00D89B26',
      color: theme.colors.text[1],
      '&:focus': {
        fontFamily: `Regular , ${theme.fontFamily}`,
        fontWeight: 'bold',
        color: theme.colors.secondary[0],
        borderColor: theme.colors.primary[0]
      }
    }
  },
  textareaInput: {
    padding: 23,
    borderRadius: 13,
    border: '2px solid white',
    outline: 'none',
    background: '#F7F9FA',
    transition: '.5s',
    fontFamily: `Medium , ${theme.fontFamily}`,
    fontSize: 13,
    borderColor: theme.colors.primary[0],
    background: '#E1F4F5',
    boxShadow: '0px 15px 25px 0px #00D89B26',
    color: theme.colors.text[1],
    minHeight: 150,
    width: '100%',
    '&:focus': {
      fontFamily: `Regular , ${theme.fontFamily}`,
      fontWeight: 'bold',
      color: theme.colors.secondary[0],
      borderColor: theme.colors.primary[0]
    }
  },
  error: {
    color: '#ED2424',
    fontFamily: 'Regular',
    fontSize: '14px',
    marginTop: 5
  },
  submitButton: {
    backgroundColor: theme.colors.primary[0],
    fontFamily: `SemiBold , ${theme.fontFamily}`,
    fontSize: 16,
    height: 43,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.colors.primary[0]
    }
  }
}));
